<template>
  <div id="cabecera">
    <nav class="navbar navbar-dark bg-dark static-top">
      <div class="container">
        <img class="logo" src="../assets/logo-servel.png">
        <a class="navbar-brand" href="#">{{Titulo}}</a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
              <a class="nav-link" href="https://www.servel.cl/">
                Servel
                <span class="sr-only">(current)</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://contacto.servel.cl">Contacto</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "cabecera",
  data() {
    return {
      Titulo: "Consulta Datos Electorales"
    };
  }
};
</script>